import { render, staticRenderFns } from "./StepStarIcon.vue?vue&type=template&id=4bdd5f8e&"
import script from "./StepStarIcon.vue?vue&type=script&lang=js&"
export * from "./StepStarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports